import React from "react";
import { Button } from "antd";
import icons from "Common/Icons";
import { Link } from "react-router-dom";
import "./Appointment.scss";
import { CONSTANTS } from "utils/constant";
class SubscribeNotTaken extends React.Component {
    _baseClassName = "schedule-appointment-container";
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    render() {
        return (
            <div className={this._baseClassName}>
                <div className="main-content">
                    <div className="phi-not-filled-content">
                        <div><img className="center-img" src={icons.info_blue}/></div>
                        <div className="center-text"> {CONSTANTS.NOT_SCHEDULED_APPOINTMENT} </div>
                        <div >
                            <Link to="/logged-in-user/subscription-plan">
                                <Button icon={<img src={icons.arrow_icon} />}> &nbsp; {CONSTANTS.TAKE_SUBSCRIPTION_PLAN}</Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SubscribeNotTaken